import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from "jalali-moment";
import { mapGetters } from "vuex";
import { getMoment } from "../helpers/Functions";
var Shortcuts = {
  NONE: "none",
  CURRENT_DAY: "currentDay",
  LAST_DAY: "lastDay",
  CURRENT_WEEK: "currentWeek",
  CURRENT_MONTH: "currentMonth"
};
export default {
  data: function data() {
    var today = getMoment().format("YYYY-MM-DD");
    return {
      startDate: today,
      endDate: today,
      selectedShortcut: Shortcuts.CURRENT_DAY
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  watch: {
    startDate: function startDate() {
      this.onDateChanged(this.startDate, this.endDate);
    },
    endDate: function endDate() {
      this.onDateChanged(this.startDate, this.endDate);
    }
  },
  methods: {
    selectShortcut: function selectShortcut(key) {
      this.selectedShortcut = key;
      var today = getMoment().format("YYYY-MM-DD");
      var yesterday = moment(today).add(-1, "days").format("YYYY-MM-DD");

      switch (key) {
        case Shortcuts.CURRENT_DAY:
          this.startDate = today;
          this.endDate = today;
          break;

        case Shortcuts.LAST_DAY:
          this.startDate = yesterday;
          this.endDate = yesterday;
          break;

        case Shortcuts.CURRENT_WEEK:
          this.startDate = moment(today).add(1, "days").startOf("week").add(-1, "days").format("YYYY-MM-DD");
          this.endDate = moment(today).add(1, "days").endOf("week").add(-1, "days").format("YYYY-MM-DD");
          break;

        case Shortcuts.CURRENT_MONTH:
          this.startDate = moment(today).startOf("jMonth").format("YYYY-MM-DD");
          this.endDate = moment(today).endOf("jMonth").format("YYYY-MM-DD");
          break;
      }
    },
    onDateChanged: function onDateChanged(startDate, endDate) {
      var date = ["".concat(startDate, " 05:00:00"), "".concat(moment(endDate).add(1, "days").format("YYYY-MM-DD"), " 05:00:00")];
      this.$emit("onDateChanged", date);
    },
    datePickerChanged: function datePickerChanged() {
      this.selectedShortcut = Shortcuts.NONE;
    }
  },
  mounted: function mounted() {
    this.onDateChanged(this.startDate, this.endDate);
  }
};